import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export default function PwaUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('Service worker registration failed:', error);
    }
  });
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!needRefresh) {
      setDismissed(false);
    }
  }, [needRefresh]);

  if (!needRefresh || dismissed) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/70 px-4 py-6">
      <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-6 shadow-2xl">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-600 text-white shadow-sm">
          <span className="text-lg font-semibold">KR</span>
        </div>
        <h2 className="mt-4 text-xl font-semibold text-slate-900">Update available</h2>
        <p className="mt-2 text-base text-slate-600">
          A new version of the app is ready. Refresh to get the latest changes.
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={() => updateServiceWorker(true)}
            className="btn btn-primary"
          >
            Refresh now
          </button>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="btn btn-secondary"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
